import CoreLayout from './components/CoreLayout';
import DownloadForm from './DownloadForm';
import Forms from './Forms';
import GForms from './GForms';
import Header from './Header';

let isInitialized = false;
CoreLayout.watchDimensions();

function init() {
  if (isInitialized) { return; }
  isInitialized = true;

  DownloadForm.init();  
  Header.init();
  
  // Note that GForms should be initialized before Forms, at least until we move the
  // select empty-option logic from GForms to generic Forms.
  GForms.init();
  Forms.init();
}

document.addEventListener('DOMContentLoaded', init);
document.addEventListener('pageshow', init);
